import Model, { attr } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

export default class AreaModel extends Model {
  declare [Type]: 'area';
  @attr('string') declare name: string;
}
